<template>
  <div class="folder">
    <div class="folder-header px-2 d-flex py-1" @click="clickDirectory(node)">
      <i v-if="!opened" class="material-icons">folder</i>
      <i v-if="opened" class="material-icons" :class="{active: opened}">folder_open</i>
      <div class="v-list__tile__title pl-3" :class="{active: opened}">{{ node.name }}</div>
      <!-- <div class="d-flex"> -->
        <!-- <i v-if="!opened" class="fas fa-angle-right ml-auto"></i>
        <i v-if="opened" class="fas fa-angle-down ml-auto"></i> -->
      <!-- </div> -->
    </div>
    <!-- <ul v-if="node.children" :style="{display:opened?'inherit':'none'}">
      <node v-for="child in node.children" :node="child" :key="child.uuid"></node>
    </ul> -->
  </div>
</template>

<script>
export default {
  name: "node",
  props: {
    node: Object
  },
  created() {
    let routeUuid = this.$router.currentRoute.params.uuid;
    this.opened = routeUuid === this.node.uuid ? true : false;
  },
  watch: {
    $route(to, from) {
      this.opened = to.params.uuid === this.node.uuid ? true : false;
    }
  },
  data() {
    return {
      opened: false
    };
  },
  methods: {
    clickDirectory(node) {
      this.$store.commit('image/emptyMultiSelectImg'); // si on change de projet en ayant sélectionné une image
      this.$router.push("/projects/" + node.uuid);
      this.$store.commit("project/setLatestProj", node);
    }
  }
};
</script>
<style lang="sass">
$active-project: #77edaf
.folder 
  display: block
  flex: 1

.folder .material-icons 
  padding-left: 0

.folder-header 
  position: relative
  cursor: pointer


.folder-header:hover 
  background-color: darken(#4a4a4a, 12%)

.folder-align
.folder-header i 
  vertical-align: middle
  padding-left: 0.3em

.folder-header span 
  display: inline-flex
  vertical-align: middle
  padding-left: 0.3em
  font-size: 1.1rem

.folder .active 
  color: $active-project
</style>
